import React, { useState } from 'react';
import './PaymentGateway.css'
import { Link } from 'react-router';
import {
  FaCartArrowDown,
  FaMobileAlt,
  FaGraduationCap,
  FaStore,
} from "react-icons/fa";
import { FaBuildingUser } from "react-icons/fa6";
const PaymentGateway = () => {
   const cards = [
    {
      title: "Payment Gateway for E-Commerce",
      text: "With Click4payPayment Gateway for online marketplaces, experience faster, secured & smoother transactions, and an easy-to-manage dashboard with advanced payment management tools. By choosing us, you give your customers various payment options to make payments from.",
      icon: <FaCartArrowDown />,
      label: "E-Commerce",
    },
    {
      title: "Payment Gateway for Apps",
      text: "Simpler the checkout, the higher the conversion. Click4payPayment Gateway is built to address your customers’ comfort & security with your App. With maximum payment modes for offline & online and a well-designed payment UI/UX, you can give the best transaction experience to your customers.",
      icon: <FaMobileAlt />,
      label: "Apps",
    },
    {
      title: "Payment Gateway for Education",
      text: "Click4payPayment Gateway for education is designed to meet the needs of large transactions of an academic organisation (School/College/University/Academy). From fee collection to reconciliation of statements, we’ve got you covered. For maximum security, our Payment Gateway is built on an A-grade security feature for maximum confidentiality.",
      icon: <FaGraduationCap />,
      label: "Education Sector",
    },
    {
      title: "Payment Gateway for Retail",
      text: "We provide payment solutions for businesses, whether convenience stores, grocery stores, clothing stores, auto retailers, home furnishing retailers, drug stores, or department stores. Click4payPayment Gateway supports maximum payment modes like debit cards, credit cards, wallets, UPI, and Cash.",
      icon: <FaStore />,
      label: "Retails",
    },
    {
      title: "Payment Gateway for PSU",
      text: "Click4payPayment Gateway for government organisations helps in seamless payment collection. A few of our PSU clients include Bihar Housing Board, Delhi Jal Board, and PCI. We provide the highest number of effective payment modes in a single checkout page—from UPI to Cards to Netbanking to e-NEFT/Cash.",
      icon: <FaBuildingUser />,
      label: "PSU",
    },
  ];

    return (
        <div className='paymentgateway'>
            <div className="container">
                 <div className="row  align-items-center">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <h3 className="wow fadeInUp">Payment Gateway</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">
               Payment Gateway Solution for All Businesses
              </h2>
              <p>Click4payprovides a vast range of products and capabilities, and a high level of
                        competence to all kinds of Businesses.</p>    
            </div>
          </div>

          
        </div>
              
           <div className="card-grid">
      {cards.map((card, index) => (
        <div className="backandfront position-relative" key={index}>
          <div className="overlay">
            <h2>{card.title}</h2>
            <p>{card.text}</p>
          </div>

          <div className="content_design">
            <div className="icon_container">{card.icon}</div>
            <p>{card.label}</p>
          <div className="bgimagealldesign"></div>
          </div>
        </div>
      ))}
    </div>
            </div>
        </div>
    );
};

export default PaymentGateway;